module.exports = __webpack_public_path__ + "img/sz.9a86ca49.svg";